/**
 * simple index页面
 */
export default {
  shopCountCard: {
    title: 'No. of calculated Shops',
    help: 'Amount of all shops included in Index Section',
    haveTotalLabel: 'No. of Monitored Shops',
    noTotalLabel: 'No. of Unmonitored Shops',
  },
  shopScatterCard: {
    title: 'Shop distribution by Index',
    help: 'Amount of all shops included in Index Section',
    haveOpt: 'No. of Monitored Shops by Opt-p',
    notOpt: 'No. of Unmonitored Shops by Opt-P',
    haveRet: 'No. of Monitored Shops by Ret-p',
    notRet: 'No. of Unmonitored Shops by Ret-P',
  },
  shopListCard: {
    title: 'Shop Index',
    help: 'Index of All Shops',
    searchForm: {
      LabelText: 'Shop Name',
      submitText: 'Submit',
    },
    tableColumns: {
      shopName: 'Shop Name',
      opt: 'Index(Opt-p)',
      ret: 'Index(Ret-p)',
      all: 'All',
      have: 'Subscribed',
      no: 'Non-subscribed',
    },
  },
  shopLineCard: {
    title: 'Simple Index Line Chart',
    help: 'To check the historical index of monitored shops and SKU index X:Time Y: index',
    export: 'Download',
    searchForm: {
      screen: 'Filter',
      type: 'Price Type',
      curr: 'Curr.',
      time: 'Time',
      submit: 'Submit',
      pleaseInput: 'Please Input',
      typeOption: {
        retail: 'Retail Price',
        optimal: 'Discounted Price',
      },
      rule: {
        shopNum: 'Please Select Shop(s)',
        makeDate: 'Please Select Time',
      },
    },
    shopDetailDialog: {
      title: 'Filter',
      title_: 'Detail',
      brand: 'Brand',
      category: 'Category',
      export: 'Download',
      brandTable: {
        brand: 'Brand',
        index: 'Index',
        detail: 'Detail',
        view: 'View',
      },
      categoryTable: {
        category: 'Category',
        index: 'Index',
        detail: 'Detail',
        view: 'View',
      },
    },
    productDetailDialog: {
      title: 'Product Detail',
      category: 'Category',
      priceType: 'Price Type',
      curr: 'Currency',
      btn: 'Close',
      tableColumns: {
        code: 'CODE',
        description: 'Description',
        image: 'Image',
        index: 'Index',
        price: 'Price',
      },
    },
  },
};
